import React from 'react';
import { useNavigate, useLocation, Link } from 'react-router-dom';
import { navigation } from '../data/mock';
import { Linkedin, Mail, ArrowUp, MapPin } from 'lucide-react';

const Footer = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleNavigation = (href) => {
    if (href.startsWith('/#')) {
      if (location.pathname !== '/') {
        navigate('/');
        setTimeout(() => {
          const element = document.querySelector(href.replace('/', ''));
          if (element) {
            element.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      } else {
        const element = document.querySelector(href.replace('/', ''));
        if (element) {
          element.scrollIntoView({ behavior: 'smooth' });
        }
      }
    } else {
      navigate(href);
    }
  };

  return (
    <footer className="relative bg-[#0a0a0b] pt-20 pb-8 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <div className="absolute top-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-white/10 to-transparent" />
        <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-[#3dd3ee]/5 rounded-full blur-[150px]" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 lg:px-8">
        {/* Main Footer Content */}
        <div className="grid md:grid-cols-4 gap-12 mb-16">
          {/* Brand Column */}
          <div className="md:col-span-2">
            <div className="mb-6">
              <span className="text-3xl font-bold text-white">Index</span>
              <span 
                className="text-3xl font-bold bg-clip-text text-transparent"
                style={{ backgroundImage: 'linear-gradient(135deg, #3dd3ee, #c8aff0)' }}
              >
                Core
              </span>
            </div>
            <p className="text-white/50 max-w-md mb-6 leading-relaxed">
              Solutions d'IA générative et de traitement de données intégrées à vos outils.
              Des produits IA prêts pour la production, adoptés par vos équipes.
            </p>
            {/* Social Links */}
            <div className="flex gap-3">
              <a
                href="https://www.linkedin.com/in/aymar-monnoyeur/"
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-white/50 hover:bg-[#3dd3ee] hover:border-[#3dd3ee] hover:text-white transition-all duration-300"
              >
                <Linkedin className="w-5 h-5" />
              </a>
              <a
                href="mailto:contact@indexcore.com"
                className="w-10 h-10 rounded-xl bg-white/5 border border-white/10 flex items-center justify-center text-white/50 hover:bg-[#3dd3ee] hover:border-[#3dd3ee] hover:text-white transition-all duration-300"
              >
                <Mail className="w-5 h-5" />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">Navigation</h4>
            <ul className="space-y-4">
              {navigation.map((item) => (
                <li key={item.name}>
                  <button
                    onClick={() => handleNavigation(item.href)}
                    className="text-white/50 hover:text-[#3dd3ee] transition-colors duration-300"
                  >
                    {item.name}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h4 className="text-lg font-bold text-white mb-6">Contact</h4>
            <ul className="space-y-4 text-white/50">
              <li>
                <a href="mailto:contact@indexcore.com" className="hover:text-[#3dd3ee] transition-colors">
                  contact@indexcore.com
                </a>
              </li>
              <li className="flex items-start gap-2">
                <MapPin className="w-4 h-4 mt-1 flex-shrink-0" />
                <span>Indexpresse – Le Spring<br />96 rue Félix Esclangon<br />38000 Grenoble</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="flex flex-col md:flex-row items-center justify-between pt-8 border-t border-white/10">
          <p className="text-sm text-white/40 mb-4 md:mb-0">
            © {new Date().getFullYear()} IndexCore – Indexpresse SAS. Tous droits réservés.
          </p>
          <div className="flex items-center gap-6">
            <Link to="/mentions-legales" className="text-sm text-white/40 hover:text-white/70 transition-colors">
              Mentions légales
            </Link>
            <Link to="/faq" className="text-sm text-white/40 hover:text-white/70 transition-colors">
              FAQ
            </Link>
          </div>
        </div>
      </div>

      {/* Scroll to Top Button */}
      <button
        onClick={scrollToTop}
        className="fixed bottom-8 right-8 w-12 h-12 bg-gradient-to-r from-[#3dd3ee] to-[#3dd3ee] hover:from-[#3dd3ee] hover:to-[#c8aff0] text-[#0a0a0b] rounded-xl flex items-center justify-center shadow-lg shadow-[#3dd3ee]/20 transition-all duration-300 hover:scale-110 z-50"
      >
        <ArrowUp className="w-5 h-5" />
      </button>
    </footer>
  );
};

export default Footer;
